import { DateFormatsEnum, formatDate } from "@src/components/utils/dateUtils";
import { EventInventoryRecord } from "@src/store/pricing/queryEventInventoryAllSlice";
import { EventRecord } from "@src/store/pricing/queryEventsSlice";
import { TContactUserPayload } from "@src/store/system/contactUserSlice";

type TConstructContactUserPayload = {
	selectedEvent: EventRecord;
	selectedRow: EventInventoryRecord;
	nameId: string | null;
	companyName: string;
	subject: string;
	message?: string;
};

export const constructContactUserPayload = (data: TConstructContactUserPayload): TContactUserPayload => {
	const { selectedEvent, selectedRow, nameId, companyName, subject, message } = data;
	const listingId = selectedRow?.Listing_ID;

	const description =
		`<p>User Name: ${nameId}</p><p>Company Name: ${companyName}</p>` +
		`<br /><p>Listing Information</p><ul>` +
		`<li>Listing ID: ${listingId}</li>` +
		`<li>Event : ${selectedEvent?.Event_Headliner}</li>` +
		`<li>Date : ${formatDate(selectedEvent?.Event_Date, DateFormatsEnum["MM/DD/YYYY"])}</li>` +
		`<li>Time : ${selectedEvent?.Event_Time}</li>` +
		`<li>Venue : ${selectedEvent?.Venue_Name}</li>` +
		`<li>Section : ${selectedRow?.Section}</li>` +
		`<li>Row : ${selectedRow?.Row}</li>` +
		`<li>Seats : ${selectedRow?.Seats}</li>` +
		`<li>Internal Notes : ${selectedRow?.Internal_Notes ?? ""}</li>` +
		`<li>External Notes : ${selectedRow?.External_Notes ?? ""}</li>` +
		`</ul><br /><p>Additional Information</p><p>${message?.trim() ? message : "/"}</p>` +
		`<a href="https://portal.stagefront.com/Pricing#listing/${listingId}">Go to Listing</a>`;

	return {
		description,
		subject: `${subject} ( Listing ID :  ${listingId} )`,
		company_name: companyName,
	};
};
